import React, { memo } from 'react'
import { BellToggle } from 'components/atoms/icons'
import { Button } from 'transfix-ui/components/Button'
import { SUBSCRIBER_NOTIFICATION_TYPE } from 'apps/fleet-planner/constants'
import { ICustomerContact, ILoadSettings } from 'apps/fleet-planner/types'

export interface ILoadSubscribersRow {
  subscribers: ICustomerContact[]
  settings?: ILoadSettings
  onClick: () => void
  onCancel: () => void
}

const SUBSCRIBERS_SUBTEXT_ENABLED_JUST_TRACK = 'Just tracking updates.'
const SUBSCRIBERS_SUBTEXT_ENABLED_ALL = 'Every status update.'
const SUBSCRIBERS_SUBTEXT_DISABLED = 'Set up status notifications'

export const SubscriberStatusRow = memo<ILoadSubscribersRow>(
  ({ subscribers = [], settings, onClick }) => {
    const { notifySubscribersAbout } = settings || {}
    const subscribersPresent = subscribers.length > 0
    const isNotificationsEnabled = notifySubscribersAbout !== undefined

    const getNotificationsTypeText = (notifType?: SUBSCRIBER_NOTIFICATION_TYPE): string => {
      if (!notifType) return ''
      return notifType === SUBSCRIBER_NOTIFICATION_TYPE.ACTIVE_STATUSES
        ? SUBSCRIBERS_SUBTEXT_ENABLED_JUST_TRACK
        : SUBSCRIBERS_SUBTEXT_ENABLED_ALL
    }

    const subscriberText = () => {
      const countSubs = subscribers.length
      let numSubs = ''
      if (countSubs === 0) {
        numSubs = 'No one'
      } else if (countSubs === 1) {
        numSubs = '1 person'
      } else numSubs = `${countSubs} people`

      return (
        <span>
          <span className={countSubs > 0 ? 'b' : ''}>{numSubs}</span> will be notified about updates
        </span>
      )
    }

    return (
      // this div id is being used in UnassignedDriverStatusRow
      <div className='flex' id='subscriber-status-row'>
        <div className='flex-shrink mt1 items-center'>
          <BellToggle isEnabled={subscribersPresent} />
        </div>
        <div className='flex-auto pl3 body-semibold '>
          {subscriberText()}
          <p className='subscribers-row-subtext'>
            {isNotificationsEnabled ? (
              <span>
                {getNotificationsTypeText(notifySubscribersAbout)}{' '}
                <Button variant='text' noPadding className='btn-text-link-b' onClick={onClick}>
                  Change
                </Button>
              </span>
            ) : (
              <Button variant='text' noPadding className='btn-text-link-b' onClick={onClick}>
                {SUBSCRIBERS_SUBTEXT_DISABLED}
              </Button>
            )}
          </p>
        </div>
      </div>
    )
  }
)
